export default __webpack_public_path__ + "static/media/bki-logo-mbl1.ba560152.svg";